import { memo, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Form from '../../components/Form';

interface ICheckoutProps {
  modeAs: 'checkout' | 'transaction' | 'preview';
}

const Checkout = memo<ICheckoutProps>(({ modeAs }) => {
  const navigate = useNavigate();
  const { id, salesKey } = useParams();

  useEffect(() => {
    if (!id && modeAs !== 'preview') {
      navigate('/');
      return;
    }
  }, [id, navigate]);

  if (!id && modeAs !== 'preview') {
    return null;
  }

  return (
    <Form id={id!} salesKey={salesKey} modeAs={modeAs} />
  );
});

export default Checkout;
